package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminListingListItem(
    val id: String,
    val title: String,
    @SerialName("seller_name") val sellerName: String?,
    @SerialName("seller_id") val sellerId: String?,
    val category: String?,
    val status: String,
    @SerialName("price_cents") val priceCents: Long,
    val currency: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("report_count") val reportCount: Int,
    @SerialName("image_urls") val imageUrls: List<String>,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
)
